export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/9ebb528a24a38f0dfdce315b753d263f.jpg"
          alt="IISRAL Recycling ehitusobjekt"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-8 pt-32 pb-24 w-full">
        <div className="max-w-2xl">
          {/* Tagline badge */}
          <div className="flex items-center gap-3 mb-7">
            <div className="w-8 h-0.5 bg-eco-green" />
            <span className="text-eco-green text-sm font-bold uppercase tracking-widest">
              Ehitusjäätmete sorteerimine ja käitlemine otse objektil
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] mb-6">
            Puhtam, kiirem ja keskkonna<span className="portrait:hidden">sõbralik</span><span className="hidden portrait:inline">-sõbralik</span> ehitusobjekt
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-white/70 font-normal leading-relaxed mb-10 max-w-lg">
            Aitame ehitusettevõtetel hoida objektid korras, vähendada jäätmekulusid ja tagada vastavus keskkonnanõuetele.
          </p>

          {/* CTA button */}
          <div className="flex items-center gap-4 flex-wrap">
            <a
              href="#kontakt"
              className="bg-eco-green text-white font-bold text-base px-8 py-4 rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-dark-green inline-flex items-center gap-2"
            >
              Võta ühendust
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        {/* Trust line */}
        <div className="mt-16 flex items-center gap-3">
          <div className="w-2 h-2 rounded-full bg-eco-green" />
          <span className="text-white/60 text-sm font-medium">Töötame ehitusettevõtetega üle Eesti</span>
        </div>
      </div>
    </section>
  );
}
